import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useEffect, useState } from "react"
import { UsersByCurrentUserRoleGroupQueryVariables, useUsersByCurrentUserRoleGroupQuery } from "../../graphql"
import { UsersList } from "./UsersList"

export type UsersByCurrentUserRoleGroupProps = {
	userRoleGroupId: string
}

export const UsersByCurrentUserRoleGroup: React.FC<UsersByCurrentUserRoleGroupProps> = ({ userRoleGroupId }) => {
	const [filter, setFilter] = useState({ userRoleGroupId })

	const [pagination, setPagination] = useState<UsersByCurrentUserRoleGroupQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useUsersByCurrentUserRoleGroupQuery({
		variables: { ...filter, pagination },
	})

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setFilter({ userRoleGroupId })
		}, 1000)

		return () => {
			clearTimeout(timeoutId)
		}
	}, [userRoleGroupId])

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.usersByCurrentUserRoleGroup.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.usersByCurrentUserRoleGroup ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading users</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.usersByCurrentUserRoleGroup.users && data?.usersByCurrentUserRoleGroup.users.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data?.usersByCurrentUserRoleGroup.users.length || 0} user
						{(data?.usersByCurrentUserRoleGroup.users.length || 0) > 1 ? "s" : ""}
					</Text>

					<UsersList users={data?.usersByCurrentUserRoleGroup.users} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more users</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any users.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
